/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import gradstop from 'gradstop';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { RGBToHex } from 'src/helpers/color-helper';
import { ELEMENTS } from 'src/constants/theme-settings';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ColorPalette extends Component<ComposedProps> {
  state = {};

  componentWillReceiveProps(nextProps) {
    const { formValues } = this.props;
    const primaryColor = _.get(formValues, `colors.${ELEMENTS.COLOR_BASE_1}`);
    const secondaryColor = _.get(formValues, `colors.${ELEMENTS.COLOR_BASE_2}`);

    const { updateField, formValues: nextFormValues } = nextProps;
    const nextPrimaryColor = _.get(nextFormValues, `colors.${ELEMENTS.COLOR_BASE_1}`);
    const nextSecondaryColor = _.get(nextFormValues, `colors.${ELEMENTS.COLOR_BASE_2}`);

    if (primaryColor !== nextPrimaryColor || secondaryColor !== nextSecondaryColor) {
      const gradient = gradstop({
        stops: 5,
        inputFormat: 'hex',
        colorArray: [nextPrimaryColor, nextSecondaryColor]
      });

      const color1 = String(RGBToHex(gradient[1])).toUpperCase();
      const color2 = String(RGBToHex(gradient[2])).toUpperCase();
      const color3 = String(RGBToHex(gradient[3])).toUpperCase();

      updateField(`colors.${ELEMENTS.COLOR_BASE_3}`, color1);
      updateField(`colors.${ELEMENTS.COLOR_BASE_4}`, color2);
      updateField(`colors.${ELEMENTS.COLOR_BASE_5}`, color3);
    }
  }

  render() {
    const { formValues } = this.props;
    const colors = _.get(formValues, `colors`);
    const { baseColor3, baseColor4, baseColor5 } = colors;

    const palette = [baseColor3, baseColor4, baseColor5];
    return (
      <div className="color-palette">
        {palette.map((item, index) => (
          <div
            key={index}
            className="color-palette-item"
            style={{ background: item }}
            data-tip={item}
            data-for="color-palette"></div>
        ))}
        <ReactTooltip id="color-palette" place="top" type="light" />
      </div>
    );
  }
}

export default withI18n()(ColorPalette);
